// extracted by mini-css-extract-plugin
module.exports = {"solar-energy-solutions":"B_AU_solar-energy-solutions__OVi3F"};